.concourse-file-uploader .drop-zone {
  border: 2px dashed var(--ion-color-medium);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.concourse-file-uploader .drag-over {
  border: 3px dashed var(--ion-color-primary);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.concourse-file-uploader .center-content {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.concourse-file-uploader .center-content ion-icon {
  margin-top: 8px;
}

.concourse-file-uploader .browse-files {
  color: var(--ion-color-primary);
  text-decoration: underline;
}
